
import {
    API_TEACHER_DETAIL,
    API_COURSE_DETAIL,
    API_COURSE_LATEST,
    API_COURSE_INDEX,
    API_ORDER_CREATE,
    API_ORDER_MY,
    API_GOODS_DETAIL,
    API_SETTINGS_BANNER,
    API_USER_SMS,
    API_USER_LOGIN,
    API_USER_AUTOLOGIN,
    API_USER_DETAIL
} from '@constant/api';

export default {
    computed: {
        statusBtnText() { // 对应操作文本
            // 1:已约 2:取消或者未约(2的时候可以约课) 3：候补中
            return function ({order_status, apply_num, capacity}) {
                switch (order_status) {
                    case '1':
                        return '取消预约';
                    case '2':
                        return apply_num < capacity ? '预约' : '申请候补';
                    case '3':
                        return '取消候补';
                    default:
                        return '';
                }
            }
        },
        statusText() { // 对应状态文本
            return function ({order_status, apply_num, capacity}) {
                switch (order_status) {
                    case '1':
                        return '取消预约';
                    case '2':
                        return apply_num < capacity ? '预约' : '申请候补';
                    case '3':
                        return `候补中，当前${apply_num}/${capacity}`;
                    default:
                        return '';
                }
            }
        }
    },
    created() {
        // 判断 autoLogin 登录
        if (this.$route.name !== 'login') {
            this.postAutoLogin({
                token: this.getQueryString('token')
            }).then(res => {
                this.loginInfo = res.result;
            }).catch(err => {
                if (!err.isLogin) {
                    this.$router.push({
                        name: 'login'
                    });
                }
            });
        }
        this.getUserDetail().then(resp => {
            window.userInfo = resp.result || {};
            this.userInfo = resp.result || {};
        });
    },
    methods: {
        getQueryString(name) {
            const reg = new RegExp('(^|&)'+ name + '=([^&]*)(&|$)');
            let r = window.location.search.substr(1);
            //r = r.substr(0, r.length - 1).match(reg);
            r = r.substr(0, r.length).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        getOrderStatus({order_status, apply_num, capacity}) {
            if (order_status === '1' || order_status === '3') {
                return {
                    status: 2,
                    msg: '取消成功'
                };
            }
            if (order_status === '2') {
                return {
                    status: apply_num < capacity ? 1 : 3,
                    msg: apply_num < capacity ? '预约成功' : '候补成功'
                };
            }
            return {};
        },
        getCourseDetail(id) {
            return this.$axios({
                method: 'get',
                url: API_COURSE_DETAIL + '/' + id
            });
        },
        getTeacherDetail(id) {
            return this.$axios({
                methods: 'get',
                url: API_TEACHER_DETAIL + '/' + id
            });
        },
        getCourseLatest(category) {
            return this.$axios({
                method: 'get',
                url: API_COURSE_LATEST,
                params: {
                    category
                }
            });
        },
        getCourseList(date, category) {
            return this.$axios({
                method: 'get',
                url: API_COURSE_INDEX,
                params: {
                    date,
                    category: category
                }
            });
        },
        createOrder(data) {
            return this.$axios({
                method: 'post',
                url: API_ORDER_CREATE,
                data: data
            });
        },
        getMyOrder(params = {}) {
            return this.$axios({
                method: 'get',
                url: API_ORDER_MY,
                params
            });
        },
        getMyHistoryOrder(params = {}) {
            return this.$axios({
                method: 'get',
                url: API_ORDER_MY,
                params: {
                    ...params,
                    histroy: true
                }
            });
        },
        getGoodsDetail(params = {}) {
            return this.$axios({
                method: 'get',
                url: API_GOODS_DETAIL,
                params
            });
        },
        getBanner() {
            return this.$axios({
                method: 'get',
                url: API_SETTINGS_BANNER
            });
        },
        postAutoLogin(data) {
            return this.$axios({
                method: 'post',
                data,
                url: API_USER_AUTOLOGIN
            });
        },
        postLogin(data) {
            return this.$axios({
                method: 'post',
                data,
                url: API_USER_LOGIN
            });
        },
        postSms(data) {
            return this.$axios({
                method: 'post',
                data,
                url: API_USER_SMS
            });
        },
        getUserDetail() {
            return this.$axios({
                method: 'get',
                url: API_USER_DETAIL
            });
        }
    },
    data() {
        return {
            IMG_PREFIX: 'http://yy.bj1993.net/',
            loginInfo: {},
            userInfo: {}
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/mixins_api.js